import React, { useState, useRef, useMemo, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import Menu from 'components/Menu';
import { FormTitle, VcEGrid, VcGrid } from 'components/Grid';

import { TableColumn } from 'components/NewTable/type';
import DateOneSePickersTyping from 'components/DatePicker/DateOneSePickersTyping';

import { isType, localeTw, userTypeList } from 'main_consts';
import { Iobject, Ioption } from 'main_type';
import {
  blobDownload,
  postExcel,
  postExcelAndFunctionName,
  confirm,
  postSearch,
  snackBarRsp,
} from 'main_api';

import { AgGridReact } from 'ag-grid-react';
import { ColDef, GridOptions } from 'ag-grid-community';

import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Alert from '@material-ui/lab/Alert';
import SearchIcon from '@material-ui/icons/Search';
import PrintIcon from '@material-ui/icons/Print';
import EditIcon from '@material-ui/icons/Edit';
import SaveIcon from '@material-ui/icons/Save';
import AttachFileIcon from '@material-ui/icons/AttachFile';
import DoneAllIcon from '@material-ui/icons/DoneAll';
import ClearIcon from '@material-ui/icons/Clear';
import RefreshIcon from '@material-ui/icons/Refresh';

import { useSnackbar } from 'notistack';
import { setLoadingRedux } from 'reducers/shareData/action';
import {
  getUserInfoRedux,
  getWareHouseListRedux,
} from 'reducers/shareData/selector';
import Select from 'components/Material/Select';
import WarehouseModal from 'components/Modal/WareHouseModal';
import Header from 'components/Header';
import {
  formatDate,
  getDateDayPlus,
  getExpressName,
  getFindDropDownList,
  getWarehouse,
  initWhrehhouse,
  selectChange,
} from '../../../main_func';

import { Iresult, Imaster } from './type';

/** 現場貨物拆櫃順序表 */
const CargoUnpackingSeqQry = (): JSX.Element => {
  const warehouseRedux = useSelector(getWareHouseListRedux);
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const [formError, setFormError] = useState(false);
  const [submitKey, setSubmitKey] = useState('search');
  const apiName = 'cargoUnpackingSeqQry';
  const [rowData, setRowData] = useState<Iresult[]>([]);
  const [openSearchTable, setOpenSearchTable] = useState(false);
  const [randomValue, setRandomValue] = useState(Math.random());
  const [expressName, setExpressName] = useState('');
  const [warehouseName, setWarehouseName] = useState('');
  const { user, userType, locationCode } = useSelector(getUserInfoRedux);
  const [lineNoOptions, setLineNoOptions] = useState<Ioption[]>([]);

  const masterDefaultValue: Imaster = {
    warehouse:
      userType === userTypeList.type1[0] || userType === userTypeList.type2[0]
        ? initWhrehhouse(userType, warehouseRedux, locationCode)
        : 'TPEE011S',
    chkCode1: '',
    // 貨櫃卸存上傳日期
    declDate: getDateDayPlus(),
    // 線別
    lineNo: '',
    declDateValid: true,
  };
  const [master, setMaster] = useState(masterDefaultValue);

  useEffect(() => {
    getFindDropDownList('findDropDownLineNo', {
      warehouse: locationCode,
    }).then((item) => {
      setLineNoOptions(item);
    });
  }, [master.warehouse]);

  useEffect(() => {
    if (
      userType &&
      !(
        isType(userTypeList.admin, userType) ||
        isType(userTypeList.type1, userType)
      )
    ) {
      setFormError(true);
      enqueueSnackbar(`您無權限使用此功能!`);
    }
    setMaster((prev) => ({ ...prev, warehouse: masterDefaultValue.warehouse }));
  }, [userType]);

  const handleSearch = async (
    e?: React.FormEvent<HTMLFormElement>
  ): Promise<void> => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }
    dispatch(setLoadingRedux(true));

    const result = await postSearch(apiName, {
      declDate: formatDate(master.declDate, 'yyyyMMdd'),
      lineNo: master.lineNo,
      warehouse: master.warehouse,
    });
    dispatch(setLoadingRedux(false));
    if (!snackBarRsp(enqueueSnackbar, result)) {
      return;
    }

    // TODO 確認List名稱
    const rowDataList = result.data.data as Iresult[];

    if (rowDataList && (rowDataList || []).length > 0) {
      setRowData(rowDataList);
      setOpenSearchTable(true);
    } else {
      setOpenSearchTable(false);
    }
    setRandomValue(Math.random());
  };

  const handleDownloadExportOfficeRpt = async (
    e?: React.FormEvent<HTMLFormElement>
  ) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }
    dispatch(setLoadingRedux(true));

    const result = await postExcelAndFunctionName(apiName, 'exportOfficeRpt', {
      declDate: formatDate(master.declDate, 'yyyyMMdd'),
      lineNo: master.lineNo,
      warehouse: master.warehouse,
    });

    blobDownload(
      result,
      enqueueSnackbar,
      `${formatDate(master.declDate, 'yyyyMM')}_${
        master.warehouse
      }_辦公室報表.xlsx`
    );
    dispatch(setLoadingRedux(false));
  };
  const handleDownloadExportBarCodeRpt = async (
    e?: React.FormEvent<HTMLFormElement>
  ) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }
    dispatch(setLoadingRedux(true));

    const result = await postExcelAndFunctionName(apiName, 'exportBarCodeRpt', {
      declDate: formatDate(master.declDate, 'yyyyMMdd'),
      lineNo: master.lineNo,
      warehouse: master.warehouse,
    });

    blobDownload(
      result,
      enqueueSnackbar,
      `${formatDate(master.declDate, 'yyyyMM')}_${
        master.warehouse
      }_工班列印條碼報表.xlsx`
    );
    dispatch(setLoadingRedux(false));
  };
  const handleDownloadExportOnSiteRpt = async (
    e?: React.FormEvent<HTMLFormElement>
  ) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }
    dispatch(setLoadingRedux(true));

    const result = await postExcelAndFunctionName(apiName, 'exportOnSiteRpt', {
      declDate: formatDate(master.declDate, 'yyyyMMdd'),
      lineNo: master.lineNo,
      warehouse: master.warehouse,
    });

    blobDownload(
      result,
      enqueueSnackbar,
      `${formatDate(master.declDate, 'yyyyMM')}_${
        master.warehouse
      }_現場列印報表.xlsx`
    );
    dispatch(setLoadingRedux(false));
  };
  const handleDownloadExportWeightBridgeRpt = async (
    e?: React.FormEvent<HTMLFormElement>
  ) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }
    dispatch(setLoadingRedux(true));

    const result = await postExcelAndFunctionName(
      apiName,
      'exportWeightBridgeRpt',
      {
        declDate: formatDate(master.declDate, 'yyyyMMdd'),
        lineNo: master.lineNo,
        warehouse: master.warehouse,
      }
    );

    blobDownload(
      result,
      enqueueSnackbar,
      `${formatDate(master.declDate, 'yyyyMM')}_${master.warehouse}_過磅單.xlsx`
    );
    dispatch(setLoadingRedux(false));
  };
  const handleDownloadExportRetainCtnr = async (
    e?: React.FormEvent<HTMLFormElement>
  ) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }
    dispatch(setLoadingRedux(true));

    const result = await postExcelAndFunctionName(apiName, 'exportRetainCtnr', {
      declDate: formatDate(master.declDate, 'yyyyMMdd'),
      lineNo: master.lineNo,
      warehouse: master.warehouse,
    });

    blobDownload(
      result,
      enqueueSnackbar,
      `${formatDate(master.declDate, 'yyyyMM')}_${master.warehouse}_留櫃單.xlsx`
    );
    dispatch(setLoadingRedux(false));
  };

  const handleConfirm = async (
    e?: React.FormEvent<HTMLFormElement>
  ): Promise<void> => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }
    dispatch(setLoadingRedux(true));

    const result = await confirm(apiName, {
      declDate: formatDate(master.declDate, 'yyyyMMdd'),
      lineNo: master.lineNo,
      warehouse: master.warehouse,
    });

    dispatch(setLoadingRedux(false));
    if (!snackBarRsp(enqueueSnackbar, result)) {
      return;
    }
    setRandomValue(Math.random());
  };

  const handleSubmit = (e?: React.FormEvent<HTMLFormElement>) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }

    if (master.declDate.length === 0) {
      master.declDate = getDateDayPlus();
    }

    if (!master.declDateValid) {
      return;
    }
    switch (submitKey) {
      case 'search':
        handleSearch();
        break;
      case 'exportOfficeRpt':
        handleDownloadExportOfficeRpt();
        break;
      case 'exportBarCodeRpt':
        handleDownloadExportBarCodeRpt();
        break;
      case 'exportOnSiteRpt':
        handleDownloadExportOnSiteRpt();
        break;
      case 'exportWeightBridgeRpt':
        handleDownloadExportWeightBridgeRpt();
        break;
      case 'exportRetainCtnr':
        handleDownloadExportRetainCtnr();
        break;
      case 'confirm':
        handleConfirm();
        break;

      default:
        break;
    }
  };

  const updateData = async (updateObj: Iobject) => {
    setMaster({ ...master, ...updateObj });
    const key: string[] = Object.keys(updateObj);
    if (key[0] === 'chkCode1' || key[0] === 'warehouse') {
      const masterTemp = { ...master, ...updateObj };
      const { chkCode1, warehouse } = masterTemp;
      let warehouseResult = { text: '', error: false };
      let expressResult = { text: '', error: false };
      if (warehouse.length > 0) {
        warehouseResult = await getWarehouse(
          updateObj,
          master as unknown as Iobject
        );
        setWarehouseName(warehouseResult.text);
      } else {
        setWarehouseName('');
      }

      if (chkCode1.length > 0) {
        expressResult = await getExpressName(
          updateObj,
          master as unknown as Iobject
        );
        setExpressName(expressResult.text);
      } else {
        setExpressName('');
      }
      setFormError(warehouseResult.error || expressResult.error);
    }
  };

  const gridRef = useRef<any>(undefined);
  const getColumnDefs = (status: boolean): ColDef[] => {
    return [
      {
        checkboxSelection: false,
        lockPosition: true,
        headerName: '項次',
        field: 'itemNo',
        valueGetter: 'node.rowIndex',
        cellClass: 'locked-col',
        suppressNavigable: true,
        maxWidth: 100,
        filter: false,
        sortable: false,
        editable: false,
        valueFormatter: (data) => {
          return data.value + 1;
        },
      },
      {
        headerName: '通關日期',
        field: 'declDate',
        width: 300,
      },
      {
        headerName: '船隻掛號',
        field: 'vesselRegNo',
        width: 300,
      },
      {
        headerName: '主號',
        field: 'mawbNo',
        width: 300,
      },
      {
        headerName: '櫃號',
        field: 'containerNo',
        width: 300,
      },
      {
        headerName: '快遞/承攬業者',
        field: 'expresssName',
        width: 150,
      },
      {
        headerName: '櫃型',
        field: 'containerForm',
        width: 150,
      },
      {
        headerName: '船名',
        field: 'vesselName',
        width: 300,
      },
      {
        headerName: '件數',
        field: 'piece',
        width: 300,
      },
      {
        headerName: '重量/KG',
        field: 'weight',
        width: 300,
      },
      {
        headerName: '通關順序',
        field: 'cclSeq',
        width: 300,
      },
    ];
  };
  const gridOptions = useMemo<GridOptions>(() => {
    const colDefs: ColDef[] = getColumnDefs(false);

    const options: GridOptions = {
      columnDefs: colDefs,
      defaultColDef: {
        flex: 1,
        minWidth: 120,
        filter: true,
        resizable: true,
        sortable: true,
        editable: false,
      },
      frameworkComponents: {},
      components: {},
      tooltipShowDelay: 1,
      headerHeight: 40,
      rowHeight: 40,
      animateRows: true,
      rowSelection: 'multiple',
      suppressRowClickSelection: true,
      multiSortKey: 'ctrl',
      localeText: localeTw,
      pagination: true,
      paginationPageSize: 100,
    };

    return options;
  }, []);

  const onGridReady = (params: any) => {
    params.api.sizeColumnsToFit();
  };

  const handleReset = async () => {
    setMaster(masterDefaultValue);
    setOpenSearchTable(false);
    setFormError(false);
    setRandomValue(Math.random());
  };
  return (
    <div id="page-area">
      <Header />
      <form onSubmit={handleSubmit} className="form-area">
        <div>
          <div className="title">
            <EditIcon /> 現場貨物拆櫃順序表
          </div>
        </div>
        <div className="input-area">
          {userType && isType(userTypeList.admin, userType) && (
            <Grid container>
              <VcEGrid item xs={12} sm={2} className="input-text">
                <FormTitle>
                  {[...userTypeList.type2, ...userTypeList.type1].indexOf(
                    userType
                  ) !== -1
                    ? '*'
                    : ''}
                  快遞倉站：
                </FormTitle>
              </VcEGrid>
              <VcGrid item xs={12} sm={3}>
                <WarehouseModal
                  value={master.warehouse}
                  updateData={updateData}
                  setStatus={setWarehouseName}
                />
              </VcGrid>

              <VcGrid item xs={12} sm={3}>
                {warehouseName && (
                  <Alert
                    severity="info"
                    style={{
                      width: '100%',
                      color: 'red',
                      margin: '0 0.5rem',
                      fontSize: '1em',
                    }}
                    icon={false}
                  >
                    {warehouseName}
                  </Alert>
                )}
              </VcGrid>
            </Grid>
          )}
          <Grid container>
            <VcEGrid item xs={12} sm={2} className="input-text">
              <FormTitle>*拆櫃日期：</FormTitle>
            </VcEGrid>
            <VcGrid item xs={12} sm={5} style={{ maxWidth: 900 }}>
              <DateOneSePickersTyping
                required
                updateData={updateData}
                style={{ maxWidth: 200 }}
                inputDataName="declDate"
                data={master}
                seInterval={31}
              />
            </VcGrid>
          </Grid>

          <Grid container>
            <VcEGrid item xs={12} sm={2} className="input-text">
              <FormTitle>線別：</FormTitle>
            </VcEGrid>
            <Grid item xs={12} sm={3}>
              <Select
                // placeholder="請先填入分號"
                value={master.lineNo}
                onChange={selectChange(updateData)}
                name="lineNo"
                options={lineNoOptions}
                // disabled={options.length === 0}
              />
            </Grid>
          </Grid>
        </div>
        <Grid container className="button-area">
          <VcEGrid item xs={12} sm={2}>
            <Button
              disabled={formError}
              type="submit"
              variant="contained"
              color="primary"
              startIcon={<SearchIcon />}
              onClick={() => setSubmitKey('search')}
            >
              查詢
            </Button>
          </VcEGrid>
          <Grid item xs={12} sm="auto">
            <Button
              disabled={
                userTypeList.type4.some((v) => v === userType) &&
                locationCode.trim().length === 0
              }
              variant="outlined"
              color="primary"
              startIcon={<RefreshIcon />}
              onClick={() => handleReset()}
            >
              重置
            </Button>
          </Grid>
          <VcEGrid item xs={12} sm="auto">
            <Button
              disabled={formError}
              type="submit"
              variant="contained"
              color="default"
              startIcon={<PrintIcon />}
              onClick={() => setSubmitKey('exportOfficeRpt')}
            >
              辦公室報表
            </Button>
          </VcEGrid>
          <Grid item xs={12} sm="auto">
            <Button
              disabled={formError}
              type="submit"
              variant="contained"
              color="default"
              startIcon={<PrintIcon />}
              onClick={() => setSubmitKey('exportBarCodeRpt')}
            >
              條碼
            </Button>
          </Grid>
          <Grid item xs={12} sm="auto">
            <Button
              disabled={formError}
              type="submit"
              variant="contained"
              color="default"
              startIcon={<PrintIcon />}
              onClick={() => setSubmitKey('exportOnSiteRpt')}
            >
              拆櫃清單
            </Button>
          </Grid>
          <Grid item xs={12} sm="auto">
            <Button
              disabled={formError}
              type="submit"
              variant="contained"
              color="default"
              startIcon={<PrintIcon />}
              onClick={() => setSubmitKey('exportWeightBridgeRpt')}
            >
              過磅單
            </Button>
          </Grid>
          <Grid item xs={12} sm="auto">
            <Button
              disabled={formError}
              type="submit"
              variant="contained"
              color="default"
              startIcon={<PrintIcon />}
              onClick={() => setSubmitKey('exportRetainCtnr')}
            >
              留櫃單
            </Button>
          </Grid>
          <Grid item xs={12} sm="auto">
            <Button
              disabled={formError}
              type="submit"
              variant="contained"
              color="primary"
              startIcon={<SaveIcon />}
              onClick={() => setSubmitKey('confirm')}
            >
              完成排櫃
            </Button>
          </Grid>
        </Grid>
      </form>
      {openSearchTable && (
        <div className="ag-theme-alpine" style={{ height: '500px' }}>
          <AgGridReact
            ref={gridRef}
            rowData={rowData}
            gridOptions={gridOptions}
            onGridReady={onGridReady}
          />
        </div>
      )}
    </div>
  );
};

export default CargoUnpackingSeqQry;
